import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        versTime: '10月15日——10月21日', //活动日期
        taskText: '赏金猎人限时任务：每天首次通关无限次元任意地图，即可获得额外的犒赏！',
        // taskText2: '赏金猎人限时任务：每天首次通关最终防线-月影幻城困难或困难以上难度，即可获得额外的犒赏！',

        //靶场模块数据及时间
        bcData: {
            Date: "10月15日——10月21日",
            rangeListID: 498
            // rangeList: ["传承-冥河摆渡人 MK.6概率翻倍", "传承-时空雕刻家 Mk.1（永久）", "移动装置II型（永久）", "热能吸收器（永久）"]
        },

        //军需补给箱模块数据及时间
        jxData: {
            Date: "10月15日——10月28日",
            jxDataID: 497
            // jxList: ['天空杀手时空箱（稀有）', '无尽RPD专属材料']
        },

        //免费福利模块数据
        freePropsData: {
            pageDate: "10月15日——10月28日",
            allPeople: [
                // 'AUG', '破军HK21', '毛瑟M1932', '精钢Hawker-1', '破军-守备官', '静音装置'
                'USP', '破军AN94', '魔煞UMP9', '精钢QBU88', '毛瑟M1932', '力量增幅器'
                // 'M249_SAW', '退魔AA12', '军灵AWP', '精钢AK47', '精钢FN57', '移动装置'
            ],
            // vip: ['高碳怒焰风暴', '钛钢UMP9', '破军光束剑']
            // vip: ['高碳QBS09', '钛钢HK21', '高碳M29']
            vip: ['高碳QBS09', '钛钢HK416', '钛钢毛瑟M1932']

        },

        //首充数据
        FirstRecharge: {
            StartTime: "2024年9月24日",
            frDataID: 491
        },

        // saleTime 为saleTIme 模块的数据

        // saleTime1: {
        //     num: "01",
        //     saleDate: "9月24日维护后——10月8日维护前",
        //     title: "君临天下大礼包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red;">“君临天下大礼包”</span>，打开即可获得：<span style="color:red;">暴君-稳定芯片，暴君武器幸运包（7天）</span>；`,
        //         `<span style="color:red;">暴君-稳定芯片</span>：`,
        //         `结合史前神秘云石制作的暴君武器专用挂件，可提高瞄准状态下的射击稳定。`,
        //         `“暴君武器专用”`,
        //         `“加装芯片后将自动与武器绑定，当武器到期后将自动卸载”`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "9月24日维护后——10月8日维护前",
        //     title: "辉煌暴君大礼包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red;">“辉煌暴君大礼包”</span>，打开即可获得：<span style="color:red;">暴君-精准芯片，暴君武器幸运包（7天）</span>；`,
        //         `<span style="color:red;">暴君-精准芯片</span>：`,
        //         `结合史前神秘云石制作的暴君武器专用挂件，能够增加瞄准射击精度。`,
        //         `“暴君武器专用”`,
        //         `“加装芯片后将自动与武器绑定，当武器到期后将自动卸载”`,
        //     ],
        //     span: []
        // },
        // saleTime4: {
        //     num: "04",
        //     saleDate: "9月24日维护后——10月8日维护前",
        //     title: "ID识别卡",
        //     saleWay: "限时特卖",
        //     p: [
        //         `1、活动期间玩家可以在游戏内商城以<span style="color:red;">原价8.5折的优惠购买ID识别卡（50）特惠包，礼包内含：“ID识别卡x50+军需补给箱x50”；</span>`,
        //         `2、活动期间玩家可以在游戏内商城以<span style="color:red;">原价7.5折的优惠购买ID识别卡（100）特惠包，礼包内含“ID识别卡x100+军需补给箱x100”；</span>`,
        //         `使用ID识别卡可开启军需补给箱，开启补给箱100%获奖，所有奖品都为点券商品。除了数十种永久武器装备外，更有机会获得游戏中从未出售过的极品非卖商品。`,
        //     ],
        //     span: []
        // },
        // saleTime5: {
        //     num: "05",
        //     saleDate: "9月24日维护后——10月8日维护前",
        //     title: "搞机箱",
        //     saleWay: "限时促销",
        //     p: [
        //         `1、活动期间玩家可以在游戏内商城以<span style="color:red;">原价7.5折的超值优惠购买“搞机箱x100”；</span>`,
        //         `打开“搞机箱”可随机获得包括“歼星巨龙时空箱（稀有）、闪电霹雳插件Lv1、能量棒”等机友商品，更有机会获得“加农巨炮（史诗）、天空杀手（史诗）、冷酷死神（史诗）”机友时空箱！`,
        //     ],
        //     span: []
        // },

        // saleTime1: {
        //     num: "01",
        //     saleDate: "10月8日维护后——10月15日维护前",
        //     title: "稀有时装",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在商城内购买到<span style="color:red">“坚毅之途（男/女）（永久）”、“无尽之途（男/女）以小搏大包”</span>，打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">无尽之途（男/女）</span>一套（至少可获得3天期限）。`,
        //         `以小搏大，圆你永久梦想！`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "10月8日维护后——10月15日维护前",
        //     title: "神器升阶材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">苍穹回响核心模块、寒霜先锋核心模块、毁灭之轮核心模块、不灭冷焰核心模块，</span>助你轻松升级你的超级神器。`,
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">神器碎片特惠礼包，</span>助你轻松升级你的超级神器。`,
        //     ],
        //     span: []
        // },
        saleTime2: {
            num: "02",
            saleDate: "10月15日维护后——10月22日维护前",
            title: "III型装置",
            saleWay: "限时特卖",
            p: [
                `活动期间玩家可在商城内购买到<span style="color:red">“供弹器III型以小搏大包、医疗装置III型以小搏大包、破片过滤网III型以小搏大包”，</span>
            打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">供弹器III型、医疗装置III型、破片过滤网III型</span>（至少可获得3天期限）。`,
                `以小搏大，圆你永久梦想！`,
            ],
            span: []
        },
        saleTime3: {
            num: "03",
            saleDate: "10月15日维护后——10月22日维护前",
            title: "机友强化大礼包",
            saleWay: "限时特卖",
            p: [
              `1、活动期间玩家可在游戏内商城以原价商品8折的特惠购买<span style="color:red;">机友强化包（死亡之翼专属）、机友强化包（杀手专属）、机友强化包（巨龙专属）、机友强化包（机甲专属）、机友强化包（死神专属）、机友强化包（巨炮专属）；</span>`,
              `礼包内物品包括：特定机友专属插件LV1，机友插件随机包x1，能量棒x50；`,
              `针对特定机友而度身定制的强化礼包，使你的小伙伴拥有超强战斗力。`,
              `2、活动期间玩家可在游戏内商城以原价商品8折的特惠购买<span style="color:red;">机友强化包（闪电霹雳版）；</span>`,
              `礼包内物品包括：闪电霹雳Lv1，机友插件随机包x1，能量棒x50；`,
              `内含所有机友都可装备的超强插件“闪电霹雳”，使你的小伙伴迅速Hold住全场。`,
            ],
            span: []
        },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "2月6日维护后——2月20日维护前",
        //     title: "永恒VIP帝王礼包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在<strong>点券商城</strong>购买<span style="color:red">永恒VIP帝王礼包</span>。`,
        //         `打开永恒VIP帝王包，可获得：永恒VIP帝王名片（专属）、永恒VIP帝王专属时装（永恒骑士（男）/永恒魔铃（女））、暴君-原始咆哮（7天）x1、暴君-熔岩爆裂（7天）x1、暴君-末日审判（7天）x1、战灵KS-23战术材料x5、传承AUGA2专属材料x5、冻结者专属材料x5、毁灭者专属材料x5、传承MP5专属材料x5、传承核心x30、ID识别卡x30、能量棒x100、逃跑清除卡x30、经验五倍卡x30、金币五倍卡x30、材料五倍卡x30。`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "2月6日维护后——2月20日维护前",
        //     title: "春节限定时装",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内<strong>点券商城</strong>内购买<span style="color:red">冰凌云裳（女）以小博大包、兔耳萌娘（女）（永久），</span><strong>VIP</strong>商城内购买到<span style="color:red">“兔女郎”</span>系列时装礼包，打卡礼包即有机会获得永久、180天、30天、7天、3天的“兔女郎”系列时装一套（至少可获得3天期限）。以小博大，圆你永久梦想！`,
        //     ],
        //     span: []
        // },
        // saleTime3: {
        //     num: "03",
        //     saleDate: "9月24日维护后——10月8日维护前",
        //     title: "量子密码卡（武器）",
        //     saleWay: "限时特卖",
        //     p: [
        //         `1、活动期间玩家可以在游戏内商城以<span style="color:red">原价8.5折的优惠购买量子密码卡（武器）（50）特惠包，礼包内含：“量子密码卡（武器）x50+量子存储箱（武器）x50”</span>； `,
        //         `2、活动期间玩家可以在游戏内商城以<span style="color:red">原价7.5折的优惠购买量子密码卡（武器）（100）特惠包，礼包内含“量子密码卡（武器）x100+量子存储箱（武器）x100”</span>；`,
        //     ],
        //     span: []
        // }
        // saleTime3: {
        //     num: "03",
        //     saleDate: "2月6日维护后——2月20日维护前",
        //     title: "春节限定武器材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内<strong>点券商城</strong>和<strong>时空精华</strong>商城购买<span style="color:red">伊瑟拉的祝福专属材料，</span>春节限定特供错过等一年！`,
        //     ],
        //     span: []
        // },
        // saleTime4: {
        //     num: "04",
        //     saleDate: "2月6日维护后——2月20日维护前",
        //     title: "变身装置升阶材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内<strong>VIP商城</strong>购买<span style="color:red">变身装置相关材料礼包，</span>助你轻松升级你的变身装置。`,
        //     ],
        //     span: []
        // },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "5月23日维护后——6月6日维护前",
        //     title: "儿童节限定时装以小搏大包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买到<span style="color:red">“卡瓦拉熊/卡瓦拉兔以小博大包”、“宝宝熊/宝宝兔以小搏大包”，</span>开启后可随机获得永久、30天、7天、3天期限的卡瓦拉熊/卡瓦拉兔、宝宝熊/宝宝兔一件（至少可获得3天期限）。以小博大，愿你永久梦想！`,
        //         `充满了童趣的绒毛玩偶服，不但能唤醒你对纯真的向往，还能雷到你的对手！`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "5月23日维护后——6月6日维护前",
        //     title: "儿童节限定武器升阶材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">玩具零件、神器碎片特惠礼包，</span>助你轻松升级你的<span style="color:red">橙级玩具机枪、橙级玩具枪</span>。`,
        //     ],
        //     span: []
        // }
        // saleTime3: {
        //     num: "03",
        //     saleDate: "10月31日维护后——11月14日维护前",
        //     title: "万圣节限定武器升阶材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">南瓜毁灭者专属材料、南瓜头武士专属材料，</span>南瓜即是正义，拿起你的南瓜毁灭邪恶吧！`,
        //     ],
        //     span: []
        // },
        // saleTime4: {
        //     num: "04",
        //     saleDate: "1月2日维护后——1月16日维护前",
        //     title: "啪啪啪的雪球",
        //     saleWay: "限时销售",
        //     p: [
        //         `1、 活动期间玩家可在游戏内商城购买<span style="color:red">“啪啪雪球大礼盒”，</span>打开即可获得：<span style="color:red">3个、5个、10个、30个及更多啪啪啪的雪球</span>；`,
        //         `2、 活动期间玩家可以在游戏内的<span style="color:red">限量商城</span>内购买<span style="color:red">“啪啪啪的雪球”</span>；`,
        //         `3、 <span style="color:red">“啪啪啪的雪球”</span>是合成节日专属武器：<span style="color:red">啪啪雪球枪</span>的主要材料，仅限节日期间产出及销售，一年仅一次千万不要错过哦！。`,
        //     ],
        //     span: []
        // },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "1月26日维护后——2月2日维护前",
        //     title: "虚空使者预售券",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可以在游戏内商城内购买<span style="color:red">“虚空使者预售券”、“虚空使者升级材料预售券”</span>；`,
        //         `<span style="color:red">虚空使者预售券：</span>购买该预售券后，可在次日以邮件的形式收到“预售伴手礼”礼包一个，2月2日维护后，可以点击“使用”按钮，并获得“虚空使者 Mk.1”一把（最高可升级至“战神-虚空使者”）；`,
        //         `<span style="color:red">虚空使者升级材料预售券：</span>购买该预售券后，2月2日维护后，可点击“使用”按钮，并获得新武器升级材料一套，助您升级至“虚空使者 Mk.2”。`,
        //     ],
        //     span: []
        // },
        saleTime1: {
            num: "01",
            saleDate: "10月15日维护后——10月22日维护前",
            title: "地狱猎人以小搏大包",
            saleWay: "限时销售",
            p: [
                `1、 活动期间玩家可在游戏内商城购买到<span style="color:red">“地狱猎人以小搏大包（男/女）”，</span>开启后可随机获得永久、180天、30天、7天、3天期限的地狱猎人(男/女)一套（至少可获得3天期限）。以小博大，愿你永久梦想！`,
                `2、 “地狱猎人”时装属性：PVE模式中提高生命上限15%。`,
                `　　如果你赞颂光明，那么也请你拥抱黑夜，如果你看到面前的阴影,别怕,那是因为你的背后有阳光。`,
                `　　“Hellhunter”`,
                `　　“PVE模式中提高生命上限15%”`,
            ],
            span: []
        }
        // saleTime5: {
        //     num: "05",
        //     saleDate: "2月6日维护后——2月20日维护前",
        //     title: "稀有挂件",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买到<span style="color:red">“涂装挂件以小搏大包（自选）</span>打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">涂装系列挂件</span>（至少可获得3天期限。以小博大，愿你永久梦想！）`,
        //     ],
        //     span: []
        // }
        // saleTime1: {
        //     num: "01",
        //     saleDate: "12月19日维护后——1月2日维护前",
        //     title: "圣诞系列时装",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在商城内购买到<span style="color:red;">“圣诞大叔/圣诞小妹（永久）、飞舞的雪花”、“圣诞之源（男/女）以小搏大包”</span>（打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red;">圣诞之源（男/女）</span>一套（至少可获得3天期限）），圣诞限定特供错过等一年！`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "12月19日维护后——1月2日维护前",
        //     title: "圣诞系列武器材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内<span style="color:red;">点券商城</span>和<span style="color:red;">时空精华商城</span>购买<span style="color:red;">雪球奔袭者专属材料、鲁道夫之角专属材料、圣诞老人的袜子，</span>圣诞限定特供错过等一年！`,
        //     ],
        //     span: []
        // }

        // saleTime4: {
        //     num: "04",
        //     saleDate: "8月15日维护后——8月29日维护前",
        //     title: "节日限定武器材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内<span style="color:red;">点券商城</span>和<span style="color:red;">限量商城</span>购买<span style="color:red;">“心星之印大礼盒”、“心星之印”，</span>材料“心星之印”可用来合成及升阶节日限定武器<span style="color:red">“猎心者”、“丘比特之箭”。</span>`,
        //     ],
        //     span: []
        // },


        // saleTime4: {
        //     num: "04",
        //     saleDate: "6月22日维护后——7月6日维护前",
        //     title: "扬我国威大礼盒",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在商城内购买<span style="color:red">“扬我国威大礼盒”，</span>
        //     打开礼包即有机会获得100个、50个、30个、10个 、5个的<span style="color:red">国威专属材料</span>。`,
        //     ],
        //     span: []
        // }
        
        // saleTime5: {
        //     num: "05",
        //     saleDate: "1月17日维护后——2月7日维护前",
        //     title: "稀有挂件",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买到<span style="color:red">“涂装挂件以小搏大包（自选）”</span>。
        //         打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">涂装系列挂件</span>（至少可获得3天期限）。以小博大，愿你永久梦想！`,
        //     ],
        //     span: []
        // }
        // saleTime2: {
        //   num: "02",
        //   saleDate: "4月16日维护后——4月29日维护前",
        //   title: "周年限定挂件",
        //   saleWay: "限时销售",
        //   p: [
        //     `活动期间玩家可在商城内购买到<span style="color:red">“8周年庆典涂装枪管（冻结者专属）以小搏大包”</span>
        //     打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">8周年庆典涂装枪管（冻结者专属）</span>一套（至少可获得3天期限）。`,
        //     `以小搏大，圆你永久梦想！`,
        //   ],
        //   span: []    
        // },
        // saleTime3: {
        //   num: "03",
        //   saleDate: "4月16日维护后——4月29日维护前",
        //   title: "传承专属材料",
        //   saleWay: "限时销售",
        //   p: [
        //     `活动期间玩家可在游戏内商城购买<span style="color:red;">邪能行者专属材料</span>助你轻松升级你的传承武器。`,
        //   ],
        //   span: []    
        // },
        // saleTime2: {
        //       num: "02",
        //       saleDate: "10月31日维护后——11月14日维护前",
        //       title: "万圣节装扮",
        //       saleWay: "限时特卖",
        //       p: [
        //         `活动期间玩家可在商城内购买到<span style="color:red;">“万圣装甲/万圣魅魔以小搏大包、“南瓜魔君（男）/南瓜魅女（女）以小搏大包”、“闪光骨头先生（男）/霓虹骨感女士（女）以小搏大包”、“骨头先生（男）/骨感女士（女）以小搏大包” 。`,
        //         `万圣节最重要的就是盛装出席！挑选你所喜欢的万圣节装扮一起来参加舞会吧！`,
        //       ],
        //       span: []    
        //     }
    },
    getters: {
        versTime: state => state.versTime
        , taskText: state => state.taskText
        , taskText2: state => state.taskText2
        , bcData: state => state.bcData
        , jxData: state => state.jxData
        , freePropsData: state => state.freePropsData
        , FirstRecharge: state => state.FirstRecharge
        , saleTime1: state => state.saleTime1
        , saleTime2: state => state.saleTime2
        , saleTime3: state => state.saleTime3
        // , saleTime4: state => state.saleTime4
        // , saleTime5: state => state.saleTime5
        // , saleTime6: state => state.saleTime6
        // , saleTime7: state => state.saleTime7
        // , saleTime8: state => state.saleTime8
        // , saleTime9: state => state.saleTime9
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js